import { css } from "@styled-system/css";

export const buttonWrapperClass = css({
	display: "flex",
	gap: "8",
});
